import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class BannerInner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    render() {
        const { content } = this.props;

        return <img src={content.src} width={content.width} height={content.height} />;
    }
}

/**
 * 定义 Navigation 组件
 */
class Banner extends React.PureComponent {
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.banner}>
                <Chip id="50162" type="struct" title="Banner" groupName="头部" content={content}>
                    <BannerInner />
                </Chip>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Banner.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Banner.defaultProps = {};

export default errorBoundary(Banner);
